export default "__VITE_ASSET__d1q5yIKv__"